import { render, staticRenderFns } from "./virtual-list.vue?vue&type=template&id=80c7676c&scoped=true"
import script from "./virtual-list.vue?vue&type=script&lang=ts"
export * from "./virtual-list.vue?vue&type=script&lang=ts"
import style0 from "./virtual-list.vue?vue&type=style&index=0&id=80c7676c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c7676c",
  null
  
)

export default component.exports